// Wake Lock Service
// Mantiene lo schermo attivo durante operazioni lunghe (es. ricerca Gemini)
// Previene timeout e interruzioni su mobile

class WakeLockService {
  constructor() {
    this.wakeLock = null;
    this.isSupported = 'wakeLock' in navigator;
  }

  /**
   * Richiedi Wake Lock per mantenere lo schermo attivo
   */
  async request() {
    // Check se già attivo
    if (this.wakeLock && !this.wakeLock.released) {
      console.log('[WakeLock] Already active');
      return true;
    }

    // Check supporto browser
    if (!this.isSupported) {
      console.log('[WakeLock] Not supported by this browser');
      return false;
    }

    try {
      this.wakeLock = await navigator.wakeLock.request('screen');
      console.log('[WakeLock] ✅ Screen wake lock activated');

      // Listener per rilascio automatico (es. tab nascosta, batteria scarica)
      this.wakeLock.addEventListener('release', () => {
        console.log('[WakeLock] Released automatically');
      });

      return true;
    } catch (err) {
      console.warn(`[WakeLock] Request failed: ${err.name}, ${err.message}`);
      return false;
    }
  }

  /**
   * Rilascia Wake Lock
   */
  async release() {
    if (this.wakeLock && !this.wakeLock.released) {
      try {
        await this.wakeLock.release();
        this.wakeLock = null;
        console.log('[WakeLock] ✅ Released manually');
        return true;
      } catch (err) {
        console.warn(`[WakeLock] Release failed: ${err.message}`);
        return false;
      }
    }
    return false;
  }

  /**
   * Check se Wake Lock è attualmente attivo
   */
  isActive() {
    return this.wakeLock && !this.wakeLock.released;
  }

  /**
   * Gestione automatica: richiedi quando il document diventa visibile
   */
  setupVisibilityListener() {
    if (!this.isSupported) return;

    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState === 'visible' && this.wakeLock && this.wakeLock.released) {
        console.log('[WakeLock] Tab visible again, re-requesting wake lock...');
        await this.request();
      }
    });
  }
}

// Export singleton
const wakeLockService = new WakeLockService();
export default wakeLockService;












